import React, {useEffect, useState} from 'react';
import {HStack, VStack} from "native-base";
import {t} from "../../../../../../services/i18n";
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import {Colors} from "../../../../../../styles/Colors";
import {useDispatch, useSelector} from "react-redux";
import {optionalSteps} from "../StepOptions";
import {updateTempSelection} from "../../../../../../redux/stepperSlice";
import {Radio} from "antd";
import CustomButtonV2 from "../../../../../common/CustomButtonV2";

const FLOW_FORM_CONNECTION_SITE = 'site';
const FLOW_FORM_CONNECTION_MANAGE = 'manage';

const FlowFormChoice = () => {
    const dispatch = useDispatch();
    const selectionsTree = useSelector(state => state.stepper.selectionsTree);
    const types = [
        {id: FLOW_FORM_CONNECTION_SITE, name: t('flow-form-connect-site-option'), explain: t('flow-form-connect-site-option-desc')},
        {id: FLOW_FORM_CONNECTION_MANAGE, name: t('flow-form-connect-manage-option'), explain: t('flow-form-connect-manage-option-desc')},
    ];
    const [selection, setSelection] = useState(selectionsTree[optionalSteps.FLOW_FORM_CHOICE] ?? types[0].id);

    useEffect(() => {
        if (!selectionsTree[optionalSteps.FLOW_FORM_CHOICE] || selectionsTree[optionalSteps.FLOW_FORM_CHOICE] !== selection)
            dispatch(updateTempSelection({[optionalSteps.FLOW_FORM_CHOICE]: selection}));
    }, [selection]);

    return (
        <Radio.Group name={'flow-form-connection-radio'} value={selection}>
            <VStack space={'1rem'} w={'100%'}>
                {types.map(type => (
                    <CustomButtonV2 key={type.id} onClick={() => setSelection(type.id)}
                                   iconProps={{iconColor: Colors.borderColor, iconHoverColor: Colors.newDesign.mainBlue}}
                                   override={({color}) => (
                                       <HStack space={'0.5rem'} alignItems={'start'} p={'1rem'} borderWidth={1} borderColor={selection === type.id ? Colors.newDesign.mainBlue : color} borderRadius={4} w={'100%'}>
                                           <Radio value={type.id} size="sm" />
                                           <VStack flex={1}>
                                               <AppText fontSize={GlobalStyleAttributes.fonts.heading3} boldFont>{type.name}</AppText>
                                               <AppText fontSize={GlobalStyleAttributes.fonts.heading4} color={Colors.newDesign.darkGrey}>{type.explain}</AppText>
                                           </VStack>
                                       </HStack>
                                   )}
                    />
                ))}
            </VStack>
        </Radio.Group>
    );
};

export default FlowFormChoice;
export {FLOW_FORM_CONNECTION_SITE, FLOW_FORM_CONNECTION_MANAGE};
